import React, { useState, useEffect } from 'react';
import { Layout, Menu, Avatar, Dropdown, Badge, Button } from 'antd';
import {
  MessageOutlined, BellOutlined, UserOutlined,
  LogoutOutlined, MenuFoldOutlined, MenuUnfoldOutlined,
} from '@ant-design/icons';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import BotonActualizar from './BotonActualizar';
import useSidebarResponsive from './useSidebarResponsive';
import FondoSidebarMobile from './FondoSidebarMobile';
import { buyerService } from '../../services/api';

const { Sider, Header, Content } = Layout;

const PujaLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  // Ancho 220 y no 200: es el que ya tenia este layout. El hook lo toma por
  // parametro justamente para no uniformar de prepo un detalle visual.
  const {
    esMobile, collapsed, alternar, cerrarSiEsMobile,
    propsSider, zIndexSider, marginLeftContenido,
  } = useSidebarResponsive(220);
  const [noLeidas, setNoLeidas] = useState(0);

  useEffect(() => {
    let vigente = true;
    const fetchCount = async () => {
      try {
        const res = await buyerService.getNoLeidasCount();
        if (vigente) setNoLeidas(res.data?.count || 0);
      } catch {
        // Silencioso a proposito: es un contador que se refresca solo cada
        // minuto en segundo plano. Nadie apreto nada, y un cartel de error
        // por no poder pintar un badge molesta mas de lo que informa. Si
        // falla, el badge queda como estaba y el resto del panel anda igual
        // — es la excepcion (c) de Skills/react-rules.md, mejora progresiva
        // que degrada sola.
      }
    };
    fetchCount();
    const intervalo = setInterval(fetchCount, 60000);
    // `vigente` evita setState despues de desmontar si la respuesta llega
    // tarde. Igual que en ClienteLayout y MainLayout: las tres copias de este
    // efecto se comportan igual. (El arreglo de fondo -un hook compartido-
    // sigue en PENDIENTES.)
    return () => { vigente = false; clearInterval(intervalo); };
  }, []);

  const menuItems = [
    {
      key: '/puja/tickets',
      icon: <MessageOutlined />,
      label: 'Consultas y Reclamos',
    },
  ];

  const userMenu = {
    items: [
      { key: 'logout', icon: <LogoutOutlined />, label: 'Cerrar Sesión', danger: true },
    ],
    onClick: ({ key }) => {
      if (key === 'logout') { logout(); navigate('/login'); }
    },
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <FondoSidebarMobile visible={esMobile && !collapsed} onClick={cerrarSiEsMobile} />

      {/* Pasa a `position: fixed` con el contenido corrido por `marginLeft`,
          igual que MainLayout y ClienteLayout. Antes iba en el flujo normal:
          funcionaba, pero al abrirlo en mobile EMPUJABA el contenido en vez de
          superponerse, dejandolo en ~155px. Y sobre todo: de estos tres
          layouts van a salir los de comisionista y admin de plataforma, asi
          que los tres tienen que comportarse igual. */}
      <Sider
        collapsible
        trigger={null}
        theme="dark"
        {...propsSider}
        style={{
          overflow: 'auto',
          height: '100vh',
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0,
          zIndex: zIndexSider,
        }}
      >
        <div className="logo">
          <h2 className={collapsed ? 'logo-collapsed' : ''}>
            {collapsed ? 'P' : 'PUJA'}
            {!collapsed && <span className="logo-bajada">Soporte</span>}
          </h2>
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={({ key }) => { navigate(key); cerrarSiEsMobile(); }}
        />
      </Sider>

      <Layout style={{ marginLeft: marginLeftContenido, transition: 'margin-left 0.2s' }}>
        <Header style={{
          padding: '0 24px',
          background: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          position: 'sticky',
          top: 0,
          zIndex: 1,
          boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        }}>
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={alternar}
          />
          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <BotonActualizar iconSize={18} />
            {/* Sin `cursor: pointer` a proposito: esta campana NO es
                clickeable. No existe `/puja/notificaciones` -las rutas de
                notificaciones viven bajo `/` y `/cliente`-, asi que el cursor
                de mano prometia una navegacion que no pasaba nada. Muestra el
                contador y nada mas. Si el admin de plataforma llega a tener su
                propia pantalla, se le agrega el onClick y vuelve el cursor.
                Ver PENDIENTES. */}
            <Badge count={noLeidas} size="small">
              <BellOutlined style={{ fontSize: 18 }} />
            </Badge>
            <Dropdown menu={userMenu} placement="bottomRight">
              <div style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}>
                <Avatar icon={<UserOutlined />} size="small" />
                <span style={{ fontSize: 13 }}>{user?.nom_usuario}</span>
              </div>
            </Dropdown>
          </div>
        </Header>

        <Content style={{ margin: 24 }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default PujaLayout;
